import React, { useState } from 'react';
import { Button, notification } from 'antd';
import { Wrapper, Title, Text, Icon } from './NoBoardFounds.style';
import { useEffect } from 'react';
import { useContext } from 'react';
import { SideBarContext } from '../../../../context/sidebarContext';
import noData from '@iso/assets/images/noData.svg';
import { DeploymentContext } from '../../../../context/deploymentContext';
import Project from '../../../Projects/Project';
import { AppContext } from '../../../../context/ContextProvider';
import { convertInfraText } from '../../../../context/helper';
import { getSandboxStatus, restoreSandbox } from '../../../../apis/Sandbox';
import LockedActionTooltip from '../../../../components/LockedActionTooltip';

export default function NoBoardFounds({ location, navigate, section, action, iconStyle, suffix, ...otherProps }) {

  const { current, setCurrent } = useContext(SideBarContext);
  const { setOpenModel, initialInfraModuleData, setInfraModuleData, setCurrentProject, initialProject, setRefreshBoardList } = useContext(AppContext);
  const { setCloneDep, setAddDep, setUpdateDep, setImportantEnabled } = useContext(DeploymentContext);
  // console.log("Location: ", location);

  // Sandbox restore — only relevant on the clusters empty state, and only
  // when the org previously had (and removed) the Brightcart sample cluster.
  const [sandboxRestorable, setSandboxRestorable] = useState(false);
  const [restoringSandbox, setRestoringSandbox] = useState(false);

  useEffect(() => {
    if (section !== "Cluster") return;
    let cancelled = false;
    getSandboxStatus()
      .then((res) => {
        const s = res.data?.data ?? res.data ?? {};
        if (!cancelled) setSandboxRestorable(s.deleted === true && s.exists !== true);
      })
      .catch(() => {});
    return () => { cancelled = true; };
  }, [section]);

  const handleRestoreSandbox = async () => {
    setRestoringSandbox(true);
    try {
      await restoreSandbox();
      notification.success({
        message: 'Sample cluster restored',
        description: 'Brightcart is back — explore Atmosly with realistic data.',
        duration: 5,
      });
      setSandboxRestorable(false);
      if (typeof setRefreshBoardList === 'function') setRefreshBoardList(true);
    } catch (err) {
      notification.error({
        message: 'Could not restore the sample cluster',
        description: err?.response?.data?.detail || err?.message || 'Something went wrong. Please try again.',
        duration: 5,
      });
    } finally {
      setRestoringSandbox(false);
    }
  };

  useEffect(() => {
    if (section === "Page not found") {
      setCurrent([""]);
    }
  }, [section]);

  return (
    <Wrapper className='not-found' {...otherProps}>
      {/* {console.log("Page not found entered...")} */}
      <Icon src={noData} style={{...iconStyle}}/>
      {["Page not found", "No Data", "No Data Found"].includes(section) && <Title>{section}</Title>}
      {!["Page not found", "No Data", "No Data Found"].includes(section) && (!["No Board"].includes(section) && !["Security Scan"].includes(section) ? <Title>You currently have no {convertInfraText[section] ? convertInfraText[section] + "s" : section}</Title> : !["Security Scan"].includes(section) ? <Text>No Data Found</Text> : <></>)}
      {!["Pipelines", "No Board", "Page not found", "No Data", "No Data Found"].includes(section) && !["Security Scan", "InfraRuns", "InfraWorkspaceAssResources", "InfraWorkspaceOutputs"].includes(section) && <Text>Let's create your first {convertInfraText[section] ? convertInfraText[section] + "s" : section} in ATMOSLY</Text>}
      {!["Page not found", "No Data", "No Data Found"].includes(section) && (!["No Board"].includes(section) && ["Security Scan"].includes(section) && <Title>Your scan list is empty</Title>)}
      {!["Pipelines", "No Board", "Page not found", "No Data", "No Data Found"].includes(section) && ["Security Scan"].includes(section) && <Text>Click here to begin your first security and compliance check!</Text>}
      {/* Every module's empty state renders its "Create …" CTA from here, so
          one guard covers them all. A read-only (trial-ended) workspace can't
          create anything — the backend answers 402 — so grey it and say why
          rather than sending the user into a create form that will fail. */}
      {!["Pipelines", "No Board", "Page not found", "No Data", "No Data Found", "InfraRuns", "InfraWorkspaceAssResources", "InfraWorkspaceOutputs"].includes(section) && <LockedActionTooltip><Button style={{
        display: "inline-flex",
        padding: "10px 57px",
        justifyContent: "center",
        alignItems: "center",
        gap: "10px",
        background: "#132f44",
        color: "var(--color-white, #FFF)",
        fontFamily: "Nunito Sans",
        fontSize: "16px",
        fontStyle: "normal",
        fontWeight: "600",
        lineHeight: "24px",
        marginTop: "20px"
      }} type="primary" onClick={() => {
        console.log("Button clicked for section: ", section);
        console.log("Button clicked for location.pathname: ", location.pathname);
        console.log("Button clicked : ", ["/all-projects", "/infra/projects"].includes(location.pathname));
        if (["Security Scan"].includes(section)) {
          action();
        }
        else {
          if (location.pathname === "Environments") {
            setCloneDep(false);
            setAddDep(false);
            setUpdateDep(false);
            localStorage.setItem('isClone', JSON.stringify(false));
            localStorage.setItem('updateDep', JSON.stringify(false));
            localStorage.setItem('addDep', JSON.stringify(false));
            localStorage.setItem('stopFetch', JSON.stringify(false));
            setImportantEnabled(false);
          }
          else if (location.pathname === "/infra/workspaces") {
            setInfraModuleData({...initialInfraModuleData, addNew: true, fromLogsPage: false});
            localStorage.setItem("InfraModule", JSON.stringify({...initialInfraModuleData, addNew: true, fromLogsPage: false}));
          }
          else if (location.pathname === "/infra/projects") {
            console.log("I am in infra/projects")
            localStorage.removeItem("Project");
            setCurrentProject(JSON.parse(JSON.stringify(initialProject)));
          }

          (location.pathname === "/cost-analyser" || location.pathname === "/security-vulnerability-list") ? 
              navigate("/integrations") : location.pathname === "/guardrail" ? 
                navigate(`${location.pathname}/add`) : location.pathname === "/infra/workspaces" ? 
                  navigate(`${location.pathname}/workspace/create`) : location.pathname === "/settings/admin/credentials-management" ?
                    navigate("/settings/admin/credentials-management/new") : ["/all-projects", "/infra/projects"].includes(location.pathname) ? 
                      setOpenModel({
                        modalType: "DETAILS_MODAL",
                        modalProps: {
                          component: <Project type="Add" />,
                          data: ""
                        }
                      }) : navigate(`${location.pathname}/create`)
        }
      }}>
        {["Security Scan"].includes(section) ? `Create` : `${suffix ? suffix : "Create"} ${convertInfraText[section] ? convertInfraText[section] : section}`}
      </Button></LockedActionTooltip>}
      {section === "Cluster" && sandboxRestorable && <Button
        type="default"
        loading={restoringSandbox}
        onClick={handleRestoreSandbox}
        style={{
          display: "inline-flex",
          padding: "10px 30px",
          justifyContent: "center",
          alignItems: "center",
          gap: "10px",
          border: "1px solid #132f44",
          color: "#132f44",
          fontFamily: "Nunito Sans",
          fontSize: "16px",
          fontStyle: "normal",
          fontWeight: "600",
          lineHeight: "24px",
          marginTop: "12px"
        }}
      >
        Bring back the sample cluster
      </Button>}
    </Wrapper>
  );
}